'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactTranslate = require('@gandi/react-translate');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDatepicker = require('react-datepicker');

var _reactDatepicker2 = _interopRequireDefault(_reactDatepicker);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _ramda = require('ramda');

var _classname = require('classname');

var _classname2 = _interopRequireDefault(_classname);

var _getShopData2 = require('../../shared/getShopData');

var _getShopData3 = _interopRequireDefault(_getShopData2);

var _sortAddressData = require('../../shared/sortAddressData');

var _sortAddressData2 = _interopRequireDefault(_sortAddressData);

var _replaceLang = require('../../shared/replaceLang');

var _replaceLang2 = _interopRequireDefault(_replaceLang);

var _FormTextfield = require('../FormTextfield/FormTextfield');

var _FormTextfield2 = _interopRequireDefault(_FormTextfield);

require('./Appointment.css');

require('react-datepicker/dist/react-datepicker.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requiredFields = ['civility', 'lastname', 'firstname', 'phoneNumber', 'email', 'date', 'hour', 'reason', 'conditions'];

var universeMotivesRestrict = {
  '597b28415ffd1': ['5d8b35c9d1b08']
};

var Appointment = function (_Component) {
  (0, _inherits3.default)(Appointment, _Component);

  function Appointment(props) {
    (0, _classCallCheck3.default)(this, Appointment);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Appointment.__proto__ || (0, _getPrototypeOf2.default)(Appointment)).call(this, props));

    var date = (0, _moment2.default)();
    _this.state = {
      hours: _this.hoursChange(date, props.shop),
      civility: props.__('Form|Mr'),
      lastname: '',
      firstname: '',
      phoneNumber: '',
      email: '',
      date: date,
      hour: '',
      universe: '',
      reason: '',
      comment: '',
      valid: '',
      conditions: false,
      hasError: false,
      errorTypes: [],
      errorFields: []
    };
    return _this;
  }

  (0, _createClass3.default)(Appointment, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (this.props.shop && nextProps.shop && this.props.shop.id !== nextProps.shop.id) {
        this.dateChange((0, _moment2.default)());
      }
    }
  }, {
    key: 'dateChange',
    value: function dateChange(date) {
      var hours = this.hoursChange(date, this.props.shop);
      this.setState(function (prevState) {
        return {
          date: date,
          hours: hours,
          hour: hours.indexOf(prevState.hour) === -1 ? '' : prevState.hour
        };
      });
      this.setErrors();
    }
  }, {
    key: 'filterDate',
    value: function filterDate(moment) {
      return Boolean(this.props.shop.openingHours[moment.weekday()][0]);
    }
  }, {
    key: 'hoursChange',
    value: function hoursChange(date, shop) {
      var hoursArray = [];

      shop && shop.openingHours && shop.openingHours[date.day()].map(function (day) {
        var from = (0, _moment2.default)(date.format('DD/MM/YYYY') + ' ' + day.from, 'DD/MM/YYYY HH:mm');
        var to = (0, _moment2.default)(date.format('DD/MM/YYYY') + ' ' + day.to, 'DD/MM/YYYY HH:mm');

        for (var i = from; i < to; i = i.add(1, 'hours')) {
          var oneHourLater = (0, _moment2.default)(i);
          oneHourLater.add(1, 'hours');

          hoursArray.push(i.format('HH:mm') + ' - ' + (oneHourLater <= to ? oneHourLater : to).format('HH:mm'));
        }
      });

      return hoursArray;
    }
  }, {
    key: 'isEmailValid',
    value: function isEmailValid(value) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(value.toLowerCase());
    }
  }, {
    key: 'isValid',
    value: function isValid() {
      var areRequiredFieldsValid = (0, _ramda.pipe)((0, _ramda.mapObjIndexed)(function (value, key) {
        return requiredFields.indexOf(key) === -1 ? true : value;
      }), _ramda.values, (0, _ramda.all)(_ramda.identity))(this.state);
      return areRequiredFieldsValid && this.isEmailValid(this.state.email);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(field, value) {
      this.setState((0, _defineProperty3.default)({}, field, value));
      this.state.hasError && this.setErrors();
    }
  }, {
    key: 'getRequiredErrors',
    value: function getRequiredErrors(state) {
      return (0, _ramda.pipe)((0, _ramda.mapObjIndexed)(function (value, key) {
        return requiredFields.indexOf(key) === -1 ? false : value ? false : key;
      }), _ramda.values, (0, _ramda.reduce)(function (acc, key) {
        return key ? acc.concat(key) : acc;
      }, []))(state);
    }
  }, {
    key: 'setErrors',
    value: function setErrors() {
      var _this2 = this;

      this.setState(function (prevState) {
        var errorTypes = [];
        var errorFields = _this2.getRequiredErrors(prevState);
        var isEmailValid = _this2.isEmailValid(prevState.email);
        errorFields.length > 0 && errorTypes.push(_this2.props.__('Form|Required fields'));
        if (!isEmailValid) {
          errorTypes.push(_this2.props.__('Form|Invalid E-mail address'));
          errorFields.push('email');
        }
        return { errorFields: errorFields, errorTypes: errorTypes };
      });
    }
  }, {
    key: 'handleUniverseValueChange',
    value: function handleUniverseValueChange(event) {
      var value = event.target.value;
      this.handleChange('universe', value);
      if (universeMotivesRestrict[value] && universeMotivesRestrict[value].indexOf(this.state.reason) === -1) {
        this.handleChange('reason', '');
      }
    }
  }, {
    key: 'handleEventValueChange',
    value: function handleEventValueChange(field, event) {
      this.handleChange(field, event.target.value);
    }
  }, {
    key: 'handleEventCheckedChange',
    value: function handleEventCheckedChange(field, event) {
      this.handleChange(field, event.target.checked);
    }
  }, {
    key: 'handleHourChange',
    value: function handleHourChange(event) {
      var hoursString = event.target.value.split(' - ');

      this.hourFrom = hoursString[0];
      this.hourTo = hoursString[1];
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit(event) {
      event.preventDefault();

      if (this.isValid()) {
        var formattedDate = this.state.date.format('YYYY/MM/DD');
        var hoursString = this.state.hour.split(' - ');
        var dateFrom = formattedDate + ' ' + hoursString[0];
        var dateTo = formattedDate + ' ' + hoursString[1];

        var state = (0, _assign2.default)({}, this.state, {
          date: formattedDate,
          dateFrom: dateFrom,
          dateTo: dateTo,
          posId: this.props.shop.id,
          countryCode: this.props.countryCode,
          language: this.props.lang.toUpperCase(),
          locale: this.props.locale
        });

        delete state.errorFields;
        delete state.errorTypes;
        delete state.hasError;
        delete state.conditions;
        delete state.hours;
        if (!state.universe) {
          delete state.universe;
        }

        this.props.submitCallback(state, this.confirmation);
        this.setState({ hasError: false });
      } else {
        this.setState({ hasError: true });
      }
      this.setErrors();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var __ = this.props.__;

      var _getShopData = (0, _getShopData3.default)(this.props.shop, this.props.countryCode),
          shopName = _getShopData.shopName,
          shopStreet = _getShopData.shopStreet,
          shopStreet1 = _getShopData.shopStreet1,
          shopZipCode = _getShopData.shopZipCode,
          shopCity = _getShopData.shopCity,
          shopState = _getShopData.shopState,
          countryCode = _getShopData.countryCode;

      this.shopName = shopName;
      this.shopStreet = shopStreet;
      this.shopStreet1 = shopStreet1;
      this.shopZipCode = shopZipCode;
      this.shopCity = shopCity;
      this.countryCode = countryCode;
      var brand = this.props.brand;
      var address = this.props.shop && (0, _sortAddressData2.default)(this.props.locale, this.countryCode, this.shopZipCode, this.shopCity, this.shopStreet, this.shopStreet1, shopState, this.shopName);

      this.confirmation = _react2.default.createElement(
        'div',
        { className: 'text-center' },
        _react2.default.createElement(
          'h3',
          { className: 'Appointment__title' },
          __('Appointment|Get an appointment')
        ),
        _react2.default.createElement(
          'div',
          null,
          __('Appointment|Confirmation')
        )
      );

      var visibleSubUniverses = void 0;

      if (this.props.shop && this.props.shop.subUniverses && this.props.shop.subUniverses.length > 0) {
        visibleSubUniverses = this.props.shop.subUniverses.filter(function (subUniverse) {
          return subUniverse.hidden === "0";
        });
      }

      return _react2.default.createElement(
        'div',
        { className: 'Appointment' },
        _react2.default.createElement(
          'div',
          { className: 'container-fluid' },
          _react2.default.createElement(
            'h3',
            { className: 'Appointment__title' },
            __('Appointment|Get an appointment')
          ),
          _react2.default.createElement(
            'div',
            { className: 'Appointment__desc' },
            __('Appointment|Description')
          ),
          _react2.default.createElement(
            'form',
            { onSubmit: this.onSubmit.bind(this), noValidate: true },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { className: 'Appointment__col Appointment__col--left col-lg-6' },
                address && address.length > 0 && _react2.default.createElement(
                  'ul',
                  { className: 'Appointment__address' },
                  address.map(function (line, index) {
                    return line && line.length > 0 && _react2.default.createElement(
                      'li',
                      { key: index },
                      line
                    );
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'Appointment__field' },
                  _react2.default.createElement(
                    'div',
                    { className: 'Appointment__civility form__input form__input--select' },
                    _react2.default.createElement('span', { className: 'form__input--select-icon icon icon-arrow-down' }),
                    _react2.default.createElement(
                      'select',
                      {
                        name: 'appointment-civility',
                        id: 'appointment-civility',
                        onChange: this.handleEventValueChange.bind(this, 'civility'),
                        value: this.state.civility
                      },
                      _react2.default.createElement(
                        'option',
                        { value: __('Form|Mr') },
                        __('Form|Mr')
                      ),
                      _react2.default.createElement(
                        'option',
                        { value: __('Form|Mrs') },
                        __('Form|Mrs')
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'Appointment__field' },
                  _react2.default.createElement(_FormTextfield2.default, {
                    fullWidth: true,
                    required: requiredFields.indexOf('lastname') !== -1,
                    name: 'appointment-lastname',
                    id: 'appointment-lastname',
                    placeholder: __('Form|Name'),
                    label: __('Form|Name'),
                    onChange: this.handleChange.bind(this, 'lastname'),
                    value: this.state.lastname,
                    error: this.state.errorFields.indexOf('lastname') !== -1
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'Appointment__field' },
                  _react2.default.createElement(_FormTextfield2.default, {
                    fullWidth: true,
                    required: requiredFields.indexOf('firstname') !== -1,
                    name: 'appointment-firstname',
                    id: 'appointment-firstname',
                    placeholder: __('Form|Surname'),
                    label: __('Form|Surname'),
                    onChange: this.handleChange.bind(this, 'firstname'),
                    value: this.state.firstname,
                    error: this.state.errorFields.indexOf('firstname') !== -1
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'Appointment__field' },
                  _react2.default.createElement(_FormTextfield2.default, {
                    fullWidth: true,
                    required: requiredFields.indexOf('phoneNumber') !== -1,
                    name: 'appointment-tel',
                    id: 'appointment-tel',
                    placeholder: __('Form|Phone'),
                    label: __('Form|Phone'),
                    onChange: this.handleChange.bind(this, 'phoneNumber'),
                    value: this.state.phoneNumber,
                    error: this.state.errorFields.indexOf('phoneNumber') !== -1
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'Appointment__field' },
                  _react2.default.createElement(_FormTextfield2.default, {
                    fullWidth: true,
                    required: requiredFields.indexOf('email') !== -1,
                    name: 'appointment-email',
                    id: 'appointment-email',
                    placeholder: __('Form|Email'),
                    label: __('Form|Email'),
                    onChange: this.handleChange.bind(this, 'email'),
                    value: this.state.email,
                    error: this.state.errorFields.indexOf('email') !== -1
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'Appointment__col Appointment__col--right col-lg-6' },
                _react2.default.createElement(
                  'div',
                  { className: (0, _classname2.default)('Appointment__field', { 'is-required': requiredFields.indexOf('date') !== -1, 'has-error': this.state.errorFields.indexOf('date') !== -1 }) },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'appointment-date', className: 'form__label' },
                    __('Form|Date')
                  ),
                  _react2.default.createElement(_reactDatepicker2.default, {
                    className: 'form__input form__input--datepicker',
                    dateFormat: 'DD/MM/YYYY',
                    filterDate: this.filterDate.bind(this),
                    id: 'appointment-date',
                    name: 'appointment-date',
                    onChange: this.dateChange.bind(this),
                    placeholder: __('Form|Date'),
                    popoverAttachment: 'top right',
                    popoverTargetAttachment: 'top right',
                    popoverTargetOffset: '100% 0px',
                    required: requiredFields.indexOf('date') !== -1,
                    selected: this.state.date
                  })
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classname2.default)('Appointment__field', { 'is-required': requiredFields.indexOf('hour') !== -1, 'has-error': this.state.errorFields.indexOf('hour') !== -1 }) },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'appointment-hours', className: 'form__label' },
                    __('Form|Hour')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'form__input form__input--select' },
                    _react2.default.createElement('span', { className: 'form__input--select-icon icon icon-arrow-down' }),
                    _react2.default.createElement(
                      'select',
                      {
                        name: 'appointment-hours',
                        id: 'appointment-hours',
                        onChange: this.handleEventValueChange.bind(this, 'hour'),
                        required: requiredFields.indexOf('hour') !== -1,
                        value: this.state.hour
                      },
                      _react2.default.createElement(
                        'option',
                        { value: '', disabled: true },
                        __('Form|Hour')
                      ),
                      this.state.hours.map(function (hour, index) {
                        return _react2.default.createElement(
                          'option',
                          { key: index, value: hour },
                          hour
                        );
                      })
                    )
                  )
                ),
                visibleSubUniverses && visibleSubUniverses.length > 0 && _react2.default.createElement(
                  'div',
                  { className: (0, _classname2.default)('Appointment__field', { 'is-required': requiredFields.indexOf('universe') !== -1, 'has-error': this.state.errorFields.indexOf('universe') !== -1 }) },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'appointment-universes', className: 'form__label' },
                    __('Appointment|Universes')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'form__input form__input--select' },
                    _react2.default.createElement('span', { className: 'form__input--select-icon icon icon-arrow-down' }),
                    _react2.default.createElement(
                      'select',
                      {
                        name: 'appointment-universes',
                        id: 'appointment-universes',
                        onChange: this.handleUniverseValueChange.bind(this),
                        required: requiredFields.indexOf('universe') !== -1,
                        value: this.state.universe
                      },
                      _react2.default.createElement(
                        'option',
                        { value: '', disabled: true },
                        __('Appointment|Universes')
                      ),
                      visibleSubUniverses.map(function (subUniverse, index) {
                        return _react2.default.createElement(
                          'option',
                          { key: index, value: '' + subUniverse.id },
                          (0, _replaceLang2.default)(subUniverse.localeLabels, subUniverse.defaultLabel, _this3.props.countryCode, _this3.props.lang)
                        );
                      })
                    )
                  )
                ),
                this.props.motives && this.props.motives.length > 0 && _react2.default.createElement(
                  'div',
                  { className: (0, _classname2.default)('Appointment__field', { 'is-required': requiredFields.indexOf('reason') !== -1, 'has-error': this.state.errorFields.indexOf('reason') !== -1 }) },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'appointment-motives', className: 'form__label' },
                    __('Appointment|Motives')
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'form__input form__input--select' },
                    _react2.default.createElement('span', { className: 'form__input--select-icon icon icon-arrow-down' }),
                    _react2.default.createElement(
                      'select',
                      {
                        name: 'appointment-motives',
                        id: 'appointment-motives',
                        onChange: this.handleEventValueChange.bind(this, 'reason'),
                        required: requiredFields.indexOf('reason') !== -1,
                        value: this.state.reason
                      },
                      _react2.default.createElement(
                        'option',
                        { value: '', disabled: true },
                        __('Appointment|Motives')
                      ),
                      this.props.motives.map(function (motive, index) {
                        return _react2.default.createElement(
                          'option',
                          {
                            disabled: universeMotivesRestrict[_this3.state.universe] && universeMotivesRestrict[_this3.state.universe].indexOf(motive.id) === -1,
                            key: index,
                            value: '' + motive.id
                          },
                          (0, _replaceLang2.default)(motive.localeLabels, motive.internationalLabel, _this3.props.countryCode, _this3.props.lang)
                        );
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: (0, _classname2.default)('Appointment__field', 'Appointment__comments', { 'is-required': requiredFields.indexOf('comment') !== -1, 'has-error': this.state.errorFields.indexOf('comment') !== -1 }) },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'appointment-comments', className: 'form__label' },
                    __('Form|Comments')
                  ),
                  _react2.default.createElement('textarea', {
                    className: 'form__input',
                    name: 'appointment-comments',
                    id: 'appointment-comments',
                    placeholder: __('Form|Comments'),
                    onChange: this.handleEventValueChange.bind(this, 'comment'),
                    required: requiredFields.indexOf('comment') !== -1,
                    value: this.state.comment
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'row row-margin-top' },
              _react2.default.createElement(
                'div',
                { className: 'Appointment__conditions Appointment__col col-lg-8' },
                _react2.default.createElement(
                  'div',
                  { className: (0, _classname2.default)('form__input--checkbox', { 'is-required': requiredFields.indexOf('conditions') !== -1, 'has-error': this.state.errorFields.indexOf('conditions') !== -1 }) },
                  _react2.default.createElement('input', {
                    name: 'appointment-conditions',
                    id: 'appointment-conditions',
                    type: 'checkbox',
                    className: 'sr-only',
                    onClick: this.handleEventCheckedChange.bind(this, 'conditions'),
                    required: requiredFields.indexOf('conditions') !== -1,
                    value: this.state.conditions
                  }),
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'appointment-conditions', className: 'form__label' },
                    __('Appointment|Conditions', { brand: brand })
                  ),
                  _react2.default.createElement('input', {
                    type: 'text',
                    id: 'appointment-valid',
                    name: 'appointment-valid',
                    className: 'sr-only',
                    onChange: this.handleChange.bind(this, 'valid'),
                    value: this.state.valid,
                    tabIndex: '-1'
                  })
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'Appointment__col Appointment__col-submit col-lg-4' },
                _react2.default.createElement(
                  'div',
                  { className: 'Appointment__errors' },
                  this.state.errorTypes.length > 0 && _react2.default.createElement(
                    'ul',
                    null,
                    this.state.errorTypes.map(function (error, key) {
                      return _react2.default.createElement(
                        'li',
                        { key: key },
                        error
                      );
                    })
                  )
                ),
                _react2.default.createElement('input', {
                  type: 'submit',
                  className: 'Appointment__submit button button--dark',
                  value: __('Form|Submit')
                })
              )
            )
          )
        )
      );
    }
  }]);
  return Appointment;
}(_react.Component);

Appointment.propTypes = {
  __: _propTypes2.default.func.isRequired, // @see https://github.com/Gandi/react-translate
  brand: _propTypes2.default.string,
  countryCode: _propTypes2.default.string,
  lang: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  motives: _propTypes2.default.array,
  shop: _propTypes2.default.object,
  submitCallback: _propTypes2.default.func
};

Appointment.defaultProps = {
  brand: 'Christian Dior Couture',
  countryCode: 'INT',
  lang: 'en',
  locale: 'en_int',
  motives: [],
  shop: null,
  submitCallback: function submitCallback() {}
};

exports.default = (0, _reactTranslate.withTranslator)()(Appointment);


//////////////////
// WEBPACK FOOTER
// ./~/ui-kit/src/components/Appointment/Appointment.js
// module id = 1161
// module chunks = 0